import modal from "@hg/modal"

import { ModalContent } from "../Modal"

interface ModalOptions {
    content: React.ReactNode
    onOk?: () => void
    onCancel?: () => void
}

export const showConfirm = ({ content, onOk, onCancel }: ModalOptions) => {
    modal.show(({ onClose }) => (
        <ModalContent
            onOk={async () => {
                await onOk?.()
                onClose()
            }}
            onCancel={() => {
                onCancel?.()
                onClose()
            }}
        >
            {content}
        </ModalContent>
    ))
}
